import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface AppConstantsMessage {
  category: string;
  tags: string[];
  value: string;
}
export interface AppConstantsRef {
  messages: AppConstantsMessage[];
}
export class AppConstants implements AppConstantsRef 
{
	private messages$: BehaviorSubject<AppConstantsMessage[]> =
		new BehaviorSubject<AppConstantsMessage[]>([]);
	get messages(): AppConstantsMessage[] 
	{
		return this.messages$.value;
	}
	constructor(values: AppConstantsRef) 
	{
		this.messages$.next(values.messages);
	}
}
const appConstantsRef: AppConstantsRef = {
	messages: [
		{
			category: 'Error',
			tags: [ 'default', 'unexpected' ],
			value: 'Unexpected error. Please try again later.'
		}
	]
};

export const expAppConstants = new InjectionToken<AppConstants>(
	'AppConstantsRef',
	{
		providedIn: 'root',
		factory: () => new AppConstants(appConstantsRef)
	}
);
